import { UserEntity } from '@core/entities/user.entity';
import { Expose, Transform, Type } from 'class-transformer';
import { BaseEntity, PaginatedEntity } from '@core/entities/_extra';
import { BannerInvoiceStatus, BannerStatus } from '@core/enums';
import { BeautifyArrayOfNumbers } from '@core/utils';
import { SafeUrl } from '@angular/platform-browser';

export class BannersListEntity extends PaginatedEntity {
  @Expose({ name: 'banners' })
  @Type(() => Array<BannerEntity>)
  banners: BannerEntity[];
}

export class BannerEntity extends BaseEntity {
  @Expose()
  @Transform((item) => encodeURIComponent(item.value), { toPlainOnly: true })
  @Transform((item) => decodeURIComponent(item.value), { toClassOnly: true })
  bannerName: string;

  @Expose()
  @Transform((item) => encodeURIComponent(item.value), { toPlainOnly: true })
  @Transform((item) => decodeURIComponent(item.value), { toClassOnly: true })
  description: string;

  bannerStartDate: string;
  bannerEndDate: string;
  redirectLink: string;
  status: BannerStatus;
  invoice: BannerInvoiceStatus;

  @Transform((item) => BeautifyArrayOfNumbers(item.value))
  category: any[];

  @Transform((item) => BeautifyArrayOfNumbers(item.value))
  placement: any[];

  // @Transform((item) => BeautifyArrayOfNumbers(item.value))
  display: any[];

  author: number;

  // Below 2 props are for Banner Stats
  @Expose({ name: 'banner_stat' })
  @Type(() => BannerStat)
  bannerStats?: BannerStat[];

  @Expose({ name: 'Totalcount' })
  totalCount = 0;

  // for ui template use
  imageUrl: SafeUrl;

  @Expose({ name: 'author_details' })
  authorDetails: Partial<UserEntity>;

  constructor(init?: Partial<BannerEntity>) {
    super();
    this.initEntity(init);
  }

  get statusBool(): boolean {
    return this.status === BannerStatus.Active;
  }

  get statusString(): string {
    return BannerStatus[this.status];
  }

  get invoiceStatusString(): string {
    return BannerInvoiceStatus[this.invoice];
  }
}

export class BannerImage {
  banner_id: number;
  banner_image: string;
}

class BannerStat {
  id: number;
  @Expose({ name: 'user_id' })
  userId: number;

  @Expose({ name: 'banner_id' })
  bannerId: number;
  gender: string;

  @Expose({ name: 'display_mode' })
  displayMode: number;
  count: number;

  @Expose({ name: 'created_at' })
  createdAt: string;

  @Expose({ name: 'updated_at' })
  updatedAt: string;
}
